import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Container } from "react-bootstrap";
import Calculator from "./Components/Calculator";

export default function App(): JSX.Element {
  return (
    <div className="App">
      <Container>
        <Calculator />
      </Container>
    </div>
  );
};